import React from 'react';
import { ChatButton } from './ChatButton';
import {
  SPLIT_IO_FEATURE_FLAG_PRODUCT_ASSISTANT,
  SPLIT_IO_FEATURE_FLAG_PRODUCT_ASSISTANT_COOKIE
} from 'constants/split';
import { useSplitTreatment } from 'hooks/splits/useSplitTreatment';
import { useChatContext } from './ChatContext';
import ChatWindow from './ChatWindow/index';

export const ProductAssistant = (): JSX.Element => {
  const { treatmentStatus } = useSplitTreatment(
    SPLIT_IO_FEATURE_FLAG_PRODUCT_ASSISTANT,
    SPLIT_IO_FEATURE_FLAG_PRODUCT_ASSISTANT_COOKIE
  );
  const { isOpen } = useChatContext();

  if (!treatmentStatus) {
    return null;
  }

  return (
    <>
      {isOpen && <ChatWindow />}
      <ChatButton ariaLabel="chat" />
    </>
  );
};
